import { memo } from "react";
import { useDispatch } from "react-redux";
import MessageBubble from "../../../../../../components/chat/messageBubble/MessageBubble";
import {
  discardTicketMessage,
  retryTicketMessage,
} from "../../../../../../features/supportTickets/supportTicketsSlice";
import { formatClock, formatFullStamp } from "../../../../../../utils/chatTime";
import styles from "./ticketMessage.module.css";

// One ticket message (see MessageBubble): support's replies carry the staff
// member's name (dashboard only), and images open full size in a new tab.
// A reply sent from here shows its images from local previews until sent.
const TicketMessage = ({ message, ticketId, side, groupStart, groupEnd, timeZone }) => {
  const dispatch = useDispatch();
  const sentAt = new Date(message.createdAt);
  // Populated attachments carry a path; unresolved ids are skipped.
  const images = (message.attachments || []).filter(
    (attachment) => attachment && typeof attachment === "object" && attachment.path,
  );

  return (
    <MessageBubble
      side={side}
      groupStart={groupStart}
      groupEnd={groupEnd}
      senderLabel={side === "support" ? message.senderName || "الدعم" : ""}
      text={message.message}
      time={formatClock(sentAt, timeZone)}
      timeTitle={formatFullStamp(sentAt, timeZone)}
      dateTime={message.createdAt}
      delivery={message.status}
      onRetry={() => dispatch(retryTicketMessage({ ticketId, message }))}
      onDiscard={() =>
        dispatch(discardTicketMessage({ ticketId, clientMessageId: message.clientMessageId }))
      }
      attachments={
        images.length > 0 && (
          <div className={`${styles.images} ${images.length === 1 ? styles.single : ""}`}>
            {images.map((image, index) => (
              <a
                key={image._id || image.path}
                href={image.path}
                target="_blank"
                rel="noreferrer"
                className={styles.image}
                title="فتح الصورة"
              >
                <img src={image.path} alt={`صورة ${index + 1}`} loading="lazy" />
              </a>
            ))}
          </div>
        )
      }
    />
  );
};

export default memo(TicketMessage);
